import React, { useRef, useEffect, memo } from "react";
import history from '../../../history';
import { routes } from '../../../constants';
import { Paginator } from 'primereact/paginator';
import { MapContainer, Marker, Polyline, Popup, TileLayer, useMap } from 'react-leaflet';
import L, { Icon, map, marker, point } from "leaflet";
import { Dialog } from 'primereact/dialog';
import polyUtil from "@mapbox/polyline";
import './deliveryManagementApp.scss'
import { useState } from "react";
import truckWhite from "../../../assets/images/icons/truck_white.png"
// import truck from "../../../assets/images/icons/truck_map.png"
import truck from "../../../assets/images/icons/truck_white_draw.png"
// import mapIcon from "../../../assets/images/icons/map.png"
import mapIcon from "../../../assets/images/icons/map-marker.svg"
import moment from "moment";

function ChangeView({ polyline }) {
  const map = useMap();

  React.useEffect(() => {
    if (polyline.length > 0) {
      const bounds = L.latLngBounds(polyline);
      map.fitBounds(bounds);
    }
  }, [polyline, map]);

  return null;
}


export const DeliveryListUI = (props) => {

  const [expandedRow, setExpandedRow] = useState(null);
  const [occurrenceData, setOccurrenceData] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const toggleExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const handleShowMap = (record) => {
    setSelectedRecord(record);
    props.onShowMap();
  };

  const getIconTruck = () => {
    return new Icon({
      iconUrl: truck,
      iconSize: [30, 30],
      iconAnchor: [15, 15],
      className: 'custom-icon',
    })
  }

  const MapWithResizeHandler = ({ polylines, originLocations, destinationLocations, positionCenter, vehicleColors }) => {
    const mapRef = useRef(null);

    useEffect(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    }, [mapRef]);

    return (
      <div style={{ width: '100%', padding: '5px' }}>
        <MapContainer center={positionCenter} zoom={5} style={{ height: '600px' }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {originLocations.map((location, index) => (
            <Marker
              icon={getIconTruck(vehicleColors[index])}
              zIndexOffset={2}
              key={"startP"}
              position={location}
              eventHandlers={{
                add: (e) => {
                  const iconElement = e.target.getElement();
                  if (iconElement) {
                    iconElement.style.setProperty('--vehicle-color', vehicleColors[index]);
                  }
                },
              }}
            />
          ))}

          {destinationLocations.map((location, index) => (
            <Marker key={`destination-${index}`} position={location} />
          ))}

          {polylines.map((polyline, index) => (
            <Polyline key={`polyline-${index}`} positions={polyline} weight={8}
              color={vehicleColors[index]}
            />
          ))}

          <ChangeView polyline={polylines.flat()} />
        </MapContainer>
      </div>
    );
  };

  const getMap = (records) => {
    let polylines = [];
    let originLocations = [];
    let destinationLocations = [];
    let vehicleColors = [];
    let positionCenter = [-15.7801, -47.9292]; // Centro padrão (Brasília)

    if (Array.isArray(records) && records.length > 0) {
      records.forEach(record => {
        if (record.geometry) {
          polylines.push(polyUtil.decode(record.geometry, 5));
        }
        if (record.origin?.address?.georeference) {
          originLocations.push(record.origin.address.georeference);
        }
        if (record.destination?.address?.georeference) {
          destinationLocations.push(record.destination.address.georeference);
        }
        if (record?.vehicleColor) {
          vehicleColors.push(record.vehicleColor);
        }
      });
    } else {
      polylines = records?.geometry ? [polyUtil.decode(records.geometry, 5)] : [];
      originLocations = records?.origin?.address?.georeference ? [records.origin.address.georeference] : [];
      destinationLocations = records?.destination?.address?.georeference ? [records.destination.address.georeference] : [];
      vehicleColors = records?.vehicleColor ? [records.vehicleColor] : []
    }

    return (
      <div style={{ width: '1200px', padding: '5px' }}>
        <MapWithResizeHandler
          vehicleColors={vehicleColors}
          polylines={polylines}
          originLocations={originLocations}
          destinationLocations={destinationLocations}
          positionCenter={positionCenter}
        />
      </div>
    );
  };

  const GetTotalWeight = (record) => {
    let totalWeight = 0.0;

    if (record?.orders) {
      record.orders.forEach(order => {
        totalWeight += order.cargo.summary.weight;
      });
      return parseFloat(totalWeight).toFixed(2) + " Kg";
    }

    return "-"

  };

  const GetTotalDistance = (record) => {
    if (record?.distance) {
      return parseFloat(record.distance).toFixed(2) + " KM"
    }

    return "-"
  }

  const GetTotalDistanceCompleted = (record) => {
    let distanceCompleted = 0
    if (record?.orders) {
      record.orders.forEach(order => {
        if (record?.occurrences) {
          record.occurrences.forEach(occurrence => {
            if (occurrence.orderCode === order.code && occurrence.code == 1) {
              if (record?.checkpoints) {
                record.checkpoints.forEach(point => {
                  if (order.oid == point.orderId) {
                    distanceCompleted = point.distanceFromPrevious
                  }
                })
              }
            }
          })
        }
      })
      return parseFloat(distanceCompleted).toFixed(2) + " KM";
    }
    return parseFloat(distanceCompleted).toFixed(2) + " KM";
  }

  const GetTotalDelivered = (record) => {
    let delivered = 0

    if (record?.occurrences) {
      record.occurrences.forEach(occurrence => {
        if (occurrence.code == 1) {
          delivered++
        }
      })

    }
    return delivered
  }
  const GetTotalDeliveryPendence = (record) => {
    let pendence = 0
    if (record?.orders) {
      pendence = record.orders.length
      if (record?.occurrences) {
        record.occurrences.forEach(occurrence => {
          if (occurrence.code == 1) {
            pendence -= record.occurrences.length
          }
        })
      }
    }
    if (pendence < 0) {
      pendence = 0
    }
    return pendence
  }

  const OnRedirectToShipment = (record) =>{
    history.push(`${routes.PATH_CARGO_SHIPMENT}/${record.oid}`)

  }

  const GetOccurrencesFailed = (record, filterByDeliveryType = false) => {
    let occ = 0
    let pendenceOrders = filterByDeliveryType ? GetTotalDeliveryPendence(record) : 0

    if (record?.occurrences) {
      record.occurrences.forEach(occurrence => {
        const isFailedOccurrence = occurrence.code != 1;
        const matchesDeliveryType = !filterByDeliveryType || occurrence.originType === "DELIVERY";

        if (isFailedOccurrence && matchesDeliveryType) {
          occ++
        }
      })
    }

    const total = occ + pendenceOrders
    return total !== 0 ? total : "-"
  }

  const GetOccurrencesFailedOnOrders = (record) => {
    return GetOccurrencesFailed(record, true)
  }

  const GetOccurrences = (record) => {
    if (!record?.orders || record.orders.length === 0) {
      return <span>Sem pedidos</span>;
    }

    return (
      <div>

        <div style={{ display: "flex", gap: "5px" }}>
          {record.occurrences && record.occurrences.map((occ, index) => {
            const isSuccess = occ?.code === 1;
            const isError = occ && (occ?.code != 0 && occ?.code !== 1 && occ.originType !== "CARGO_SHIPMENT");
            const isDriverOccurrence = occ.originType === "CARGO_SHIPMENT"

            return (
              <button
                key={`order-${index}`}
                title={isSuccess ? "Pedido: " + occ.orderCode + " " + occ.occurrenceTypeDescription + ": " + occ?.description : isError ? "Pedido: " + occ.orderCode + " " + occ.occurrenceTypeDescription + ": " + occ?.description : isDriverOccurrence ? occ.occurrenceTypeDescription + ": " + occ?.description : "Sem ocorrência"}
                onClick={(e) => {
                  e.stopPropagation();
                  if (isError || isSuccess || isDriverOccurrence) {
                    setOccurrenceData(occ);
                    props.onShowCanhoto(occ?.image);
                  }
                }}
                style={{
                  width: "30px",
                  height: "40px",
                  backgroundColor:
                    isSuccess
                      ? "#00BA37" // Verde para sucesso
                      : isDriverOccurrence
                        ? "#fff2af" // Amarelo para motorista
                        : "#FFA2A2", // Vermelho para erro
                  borderBottom: "1px solid black",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                {isSuccess && (
                  <i className="pi pi-check" style={{ color: "white", fontSize: "25px" }}></i>
                )}
                {isDriverOccurrence && (
                  <i className="pi pi-exclamation-triangle" style={{ color: "red", fontSize: "20px" }}></i>
                )}
              </button>
            );
          })}
          {[...Array(GetTotalDeliveryPendence(record))].map((_, i) => (
            <button
              key={`pending-${i}`}
              title="Entrega pendente"
              style={{
                width: "30px",
                height: "40px",
                backgroundColor: "#d5d5d5",
                borderBottom: "1px solid black",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
            />
          ))}

        </div>
        <div>
          {record?.situation === "FINISHED_MANUALY" && <span style={{color: "red", fontSize: "16px"}} >{record?.obs}</span>}
        </div>
      </div>
    );
  };

  const downloadImage = (occurrence) => {
    var a = document.createElement("a");
    document.body.append(a);
    a.href = occurrence.image;
    // a.download = occurrence.orderCode + "_image.png";
    a.click();
    a.remove();
  }


  return (
    <div>
      {/* HEADER */}
      <div className="column-body">
        <div className="column-content">
          <div className="column-custom"></div>
          <div className="column-custom"></div>
          <div className="column-custom">Veículo</div>
          <div className="column-custom">Peso Total</div>
          <div className="column-custom">Km Planejados</div>
          <div className="column-custom">Km Realizados</div>
          <div className="column-custom">Pontos de Entregas</div>
          <div className="column-custom">Entregas Realizadas</div>
          <div className="column-custom">Entregas Pendentes</div>
          <div className="column-custom">Ocorrências</div>
          {/* <div></div> */}
        </div>
      </div>

      {/* ROWS */}
      <div className="row-body">
        {props.records && props.records.length > 0 ? (
          props.records.map((record, index) => (
            <React.Fragment key={index}>
              <div className="row-content" onClick={() => toggleExpand(index)} style={{ borderRadius: "15px", cursor: "pointer", backgroundColor: expandedRow === index ? "#f0f0f0" : "white", }}>
                <div className="row-map">
                  <button style={{ border: "none", backgroundColor: "transparent" }} onClick={(e) => { e.stopPropagation(); handleShowMap(record) }}>
                    <img className="map-icon" src={mapIcon} alt="Mapa" />
                  </button>
                </div>
                <div className="row-truck" style={{ '--truck-color': record?.vehicleColor }}>
                  <img className="truck-icon" src={truckWhite} title={"Embarque número: " + record?.oid} />
                </div>
                <div style={{ fontWeight: "bold" }} className="row-custom">{record.vehicle.plate}</div>
                <div className="row-custom">{GetTotalWeight(record)}</div>
                <div className="row-custom">{GetTotalDistance(record)}</div>
                <div className="row-custom km-custom">{GetTotalDistanceCompleted(record)}</div>
                <div style={{ fontWeight: "bold" }} className="row-custom">{record?.checkpoints.length}</div>
                <div className="row-custom delivered-custom delivered" >{GetTotalDelivered(record)} </div>
                <div className="row-custom delivered-custom pendence" onClick={(e)=>OnRedirectToShipment(record)} >{GetOccurrencesFailedOnOrders(record, true)}</div>
                <div style={{ fontWeight: "bold" }} className={`row-custom ${GetOccurrencesFailed(record) !== "-" ? "has-occurrences" : ""}`}>{GetOccurrencesFailed(record)}</div>
                <i className="pi pi-arrow-down detail-indicator"></i>
              </div>
              {expandedRow === index && (
                <div className="row-details">
                  <div className="row-detail-custom">
                    {GetOccurrences(record)}
                  </div>
                </div>
              )}
              {props.map.visible && (
                <Dialog
                  header={
                    <div className="lxButtonDialogHeader">
                      <div className="lxHeaderTitle">
                        <h3>{props.map.header}</h3>
                      </div>
                      <button
                        className="p-dialog-titlebar-icon p-link lxHeaderClose"
                        onClick={() => {
                          setSelectedRecord(null);
                          props.onHideMap();
                        }}
                      >
                        <span className="pi pi-times"></span>
                      </button>
                    </div>
                  }
                  closable={false}
                  visible={props.map.visible}
                  modal={props.map.modal}
                  onHide={() => {
                    setSelectedRecord(null);
                    props.onHideMap();
                  }}
                >
                  {selectedRecord && getMap(selectedRecord)}
                </Dialog>
              )}

              {props.showMapGeral && (
                <Dialog
                  header={
                    <div className="lxButtonDialogHeader">
                      <div className="lxHeaderTitle">
                        <h3>{props.map.header}</h3>
                      </div>
                      <button
                        className="p-dialog-titlebar-icon p-link lxHeaderClose"
                        onClick={() => {
                          setSelectedRecord(null);
                          props.onHideMapGeral();
                        }}
                      >
                        <span className="pi pi-times"></span>
                      </button>
                    </div>
                  }
                  closable={false}
                  visible={props.showMapGeral}
                  modal={props.map.modal}
                  onHide={() => {
                    setSelectedRecord(null);
                    props.onHideMapGeral();
                  }}
                >
                  {props.records && getMap(props.records)}
                </Dialog>
              )}
              {props.dialogCanhoto.visible && (
                <Dialog
                  header={
                    <div className="lxButtonDialogHeader">
                      <div className="lxHeaderTitle">
                        <h3>{props.dialogCanhoto.header}</h3>
                      </div>
                      <button
                        className="p-dialog-titlebar-icon p-link lxHeaderClose"
                        onClick={() => {
                          setSelectedRecord(null);
                          props.onHideCanhoto();
                        }}
                      >
                        <span className="pi pi-times"></span>
                      </button>
                    </div>
                  }
                  closable={false}
                  visible={props.dialogCanhoto.visible}
                  modal={props.dialogCanhoto.modal}
                  onHide={() => {
                    setSelectedRecord(null);
                    props.onHideCanhoto();
                  }}
                >
                  <div className="detail-occurrence-body">
                    <p>
                      <strong>Código da ocorrência: </strong> {occurrenceData.code}
                    </p>
                    <p>
                      <strong>Descrição da ocorrência: </strong> {occurrenceData.occurrenceTypeDescription}
                    </p>
                    <p>
                      <strong>Descrição: </strong> {occurrenceData.description}
                    </p>
                    <p>
                      <strong>Data: </strong> {moment(occurrenceData.date).format("DD/MM/YYYY")}
                    </p>
                    {occurrenceData?.image && (
                      <React.Fragment>
                        <button title="Baixar imagem" onClick={() => { downloadImage(occurrenceData) }}><i className="pi pi-download"></i></button>
                        <div className="detail-occurrence-image-container">
                          <div className="detail-occurrence-image">
                            <img title="Baixar imagem" onClick={() => { downloadImage(occurrenceData) }} className="image" src={occurrenceData.image} />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </Dialog>
              )}
            </React.Fragment>
          ))
        ) : (
          <span className="empty-records">Não há dados de embarque</span>
        )}
      </div>
      <div>
        <Paginator className="pagination" first={props.index} rows={props.max} totalRecords={props.count} rowsPerPageOptions={[10, 20, 30, 50]} onPageChange={(e) => { props.onPagination(e) }} />
      </div>
    </div>
  );
};